// extracted by mini-css-extract-plugin
export default {"basket":"Basket_basket__J9Bne","save_btn":"Basket_save_btn__yieeU","scanner_btn":"Basket_scanner_btn__iDzL4","basket_item":"Basket_basket_item__PjdI3"};